import Grid from '@mui/joy/Grid'
import Typography from '@mui/joy/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import React from 'react'
import { Card, Container } from '@mui/joy'
import { useNavigate } from 'react-router-dom'

function EmptyRewards() {
  const navigate = useNavigate()

  function goTo(route: string) {
    navigate(route)
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
    >
      <Grid sx={{ pb: 2, pt: 2 }}>
        <Typography
          level="h4"
          sx={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
          onClick={() => goTo('/')}
        >
          <ArrowBackIcon />
          Vissza az üzleteimhez
        </Typography>
      </Grid>

      <Container maxWidth="xs">
        <Card size="lg">
          <Typography>Nincs beváltható ajándékod</Typography>
        </Card>
      </Container>
    </Grid>
  )
}

export default EmptyRewards
